import PageDefauleTemplate from "../../components/Common/PageDefauleTemplate";
import QuizSetComponent from "../../components/SolveQuizPage/QuizSetComponent";

const ShowQuizSetPage = () => {
  return (
    <>
      <PageDefauleTemplate pageName="퀴즈 풀기">
        <QuizSetComponent />
      </PageDefauleTemplate>
    </>
  );
};
export default ShowQuizSetPage;
